export function emailComparisonKey(email: string): string {
	return email.trim().toLowerCase();
}

// LSP-17767 (testing follow-up): does a share row belong to one of the given identity values
// (the current user's email / account id, the project creator's, ...)? Both sides must be
// PRESENT: resolved roster rows can carry no userIdentifier and identity fields can be
// momentarily unloaded, and a bare == there made undefined match undefined — removing ANYONE
// read as self-removal (closing the project page) and identifier-less rows got "(You)"/
// "(Creator)" labels. One predicate so the three call sites can't drift.
export function shareRowMatchesIdentity(userIdentifier: unknown, identityValues: Array<unknown>): boolean {
	if (userIdentifier === null || userIdentifier === undefined || userIdentifier === "") return false;
	// Email storage is canonical now, but the session/User email can retain casing. Opaque
	// identifiers keep the existing loose equality contract and remain case-sensitive.
	// eslint-disable-next-line eqeqeq
	return identityValues.some((value) => {
		if (value === null || value === undefined || value === "") return false;
		if (typeof userIdentifier === "string" && typeof value === "string" && userIdentifier.includes("@") && value.includes("@")) {
			return emailComparisonKey(userIdentifier) === emailComparisonKey(value);
		}
		// eslint-disable-next-line eqeqeq
		return value == userIdentifier;
	});
}
